import './LoadingSpinner.css'
function LoadingSpinner() {
    return (<div className='loadingContainer'>
        
    </div>);
}
export {LoadingSpinner};